<div class="advanced-search">
  <app-advanced-search-pane></app-advanced-search-pane>
  <app-advanced-search-table></app-advanced-search-table>
</div>
